var lists_default = {
  "fontElementMap": "_0xc8B",
  "orderedlist": "ml5Vo",
  "bulletedlist": "XEma6",
  "listItem": "_110Xd",
  "checkboxList": "DUU60",
  "checkboxInput": "uoCQD"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
